import axios from "axios";

import Config from "src/config";

const v3_marketing_criarCampanhas_action = data => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/v3/marketing/campanhas`,
        data,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,
    });
};

export default v3_marketing_criarCampanhas_action;
